module.exports = __webpack_public_path__ + "img/coin.e3c8732d.png";